import { useTranslation } from 'react-i18next';

export default function Promo() {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-primary-600 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6">
            {t('promo.title')}
          </h2>
          <p className="text-xl mb-8">
            {t('promo.description')}
          </p>
          <button className="bg-white text-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors">
            {t('promo.cta')}
          </button>
        </div>
      </div>
    </section>
  );
}
